import { ClientRequisite } from '../../payout-tickets/core/_models'
import { IPaymentRequisite } from '../../../../types'

export enum EClientFlags {
  white = 'white',
  red = 'red',
  yellow = 'yellow',
  green = 'green',
  blue = 'blue',
  black = 'black',
  orange = 'orange',
  purple = 'purple',
}

export interface PlatformInClient {
  id: number
  uuid: string
}

export interface MerchantInClient {
  token: string
  title: string
}

export interface OptionsInClient {
  color: string
}

export interface IClientItem {
  //external_user
  id?: number
  platform: PlatformInClient
  merchant: MerchantInClient
  externalId: string
  options: OptionsInClient
  token: string
  comment: string | null
  lastActivityDate: string | null
  createdAt: string
  requisites: Array<ClientRequisite>
  paymentRequisites: Array<IPaymentRequisite>
  paymentSum: number | null
  payoutSum: number | null
  color: string
  merchantTitle: string
  riskPoints?: number
  /** Ручная часть целиком: бессрочная корректировка плюс временная (если она есть) */
  manualRiskPointChange?: number
  /** Временная корректировка: сколько снимется, когда и за что (null — корректировки нет) */
  manualRiskPendingChange?: number | null
  manualRiskExpiresAt?: string | null
  manualRiskReason?: string | null
  /** Персональный запрет создавать выплаты в мэтчинге. К риск-баллу отношения не имеет */
  matchingPayoutRestricted?: boolean
}

export interface ClientEditRequest {
  color: string
  comment: string
}

export interface RiskScoreChangeRequest {
  /** Новое АБСОЛЮТНОЕ значение бессрочной корректировки, а не дельта к прежнему */
  permanentChange: number
  reason: string
}

export interface MatchingPayoutRestrictionRequest {
  /** Состояние, в котором должен оказаться клиент, а не переключение относительно текущего */
  restricted: boolean
}

export interface TemporaryRiskScoreChangeRequest {
  /** Новое АБСОЛЮТНОЕ значение временной корректировки; 0 — снять её */
  value: number
  reason: string
  /** Срок в минутах (1..43200). Не нужен только при value = 0 */
  durationMinutes?: number
}
